import { render, staticRenderFns } from "./botones_interfaz_proveedor.vue?vue&type=template&id=60212988&lang=pug&"
import script from "./botones_interfaz_proveedor.vue?vue&type=script&lang=js&"
export * from "./botones_interfaz_proveedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports